import type { ComponentType } from 'react';
import type { PropsPantalla } from '../tipos';
import { Catalogo } from './catalogo/Catalogo';
import { Duplicados } from './duplicados/Duplicados';
import { Importar } from './importar/Importar';
import { Proteccion } from './proteccion/Proteccion';

/** Pantalla de cada apartado de «Clientes» por la clave de su entrada anidada (G141). Sin pantalla, su hueco. */
export const APARTADOS_CLIENTES: Readonly<Partial<Record<string, ComponentType<PropsPantalla>>>> = {
    clientes_duplicados: Duplicados,
    clientes_importar: Importar,
    clientes_privacidad: Proteccion,
    clientes_catalogo: Catalogo,
};
